var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"connection-status mt-1"},[(!_vm.isPending)?[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.statusText))]),_vm._v(" "),_c('span',{staticClass:"status-indicator",class:_vm.statusClasses})]:[_c('span',{staticClass:"mr-2"},[_vm._v("Connecting...")]),_vm._v(" "),_c('span',{staticClass:"status-indicator unknown"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }